export default __webpack_public_path__ + "bml-unfold2e2c34.svg";